/* eslint-disable no-undef */
import { chooseLocation } from "./lib/chooseLocation";
import { openLocation } from "./lib/openLocation";

const install = function (Vue, opts = {}) {
  //地图配置
  if (opts.mapKey) {
    const keys = Array.isArray(opts.mapKey) ? opts.mapKey : [opts.mapKey];
    SmartMap.mapKeys = keys;
    SmartMap.mapKey = keys[0];
  }
  if (opts.mapType) {
    SmartMap.mapType = opts.mapType;
  }
  if (opts.height) {
    SmartMap.height = opts.height;
  }
  if (opts.width) {
    SmartMap.width = opts.width;
  }
};

const SmartMap = {
  mapType: "amap", //地图类型
  mapKey: "",
  mapKeys: [],
  //获取地图key
  getMapKey() {
    return this.mapKey;
  },
  //获取随机地图key
  getRandomMapKey() {
    const random = Math.random() * this.mapKeys.length;
    const index = Math.floor(random);
    return this.mapKeys[index];
  },
  width: "1000px",
  height: "500px",
  install,
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  chooseLocation,
  openLocation,
};

export default SmartMap;
